import {
  TransactionStatus,
  TransactionType,
  isPatientEClaimTransactionExtendedData,
} from '@principle-theorem/principle-core/interfaces';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GeneralProviderActionsService } from '../../../general-provider-actions.service';
import {
  ITransactionAction,
  ITransactionActionsData,
} from '../../../transaction-action';
import { TransactionHelpers } from '../../../transaction-helpers';
import { EasyclaimTransactionExtendedData } from '../easyclaim-transaction';

export class VoidEasyclaimTransaction
  implements ITransactionAction<EasyclaimTransactionExtendedData>
{
  icon = 'block';
  label = 'Void';
  tooltip = 'Void if claim has been manually cancelled via Medicare';
  inProgress$ = new BehaviorSubject<boolean>(false);
  typeGuardFn = isPatientEClaimTransactionExtendedData;

  constructor(private _actions: GeneralProviderActionsService) {}

  canDo$(
    data: ITransactionActionsData<EasyclaimTransactionExtendedData>
  ): Observable<boolean> {
    return TransactionHelpers.lastTransaction$(
      data,
      isPatientEClaimTransactionExtendedData
    ).pipe(
      map((transaction) => {
        if (!transaction) {
          return false;
        }
        return (
          transaction.type === TransactionType.Incoming &&
          transaction.status !== TransactionStatus.Failed
        );
      })
    );
  }

  async do(
    data: ITransactionActionsData<EasyclaimTransactionExtendedData>
  ): Promise<void> {
    this.inProgress$.next(true);
    await this._actions.cancel(
      data.invoice,
      data.latestTransaction,
      'Void Medicare Claim'
    );
    this.inProgress$.next(false);
  }
}
